export default __webpack_public_path__ + "static/media/border.ecf6766b.png";